// OfficialsSection

import Container from "../../../components/ui/Container";
import SectionHeader from "../../../components/ui/SectionHeader";
import OfficialCard from "../../../components/cards/OfficialCard";
import { incomingOfficials } from "../constants/officialsData";

export default function OfficialsSection() {
  return (
    <section
      id="officials"
      className="event-noise bg-twilight-indigo-950 px-0 py-20 text-white md:py-28"
    >
      <Container>
        <div className="mb-14">
          <SectionHeader
            eyebrow="Leadership"
            title="Incoming"
            accent="Officials"
            description="Meet the newly elected officials who will lead the University of Liberia Faculty Association into its next chapter of service and progress."
          />
        </div>

        <div className="grid gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
          {incomingOfficials.map((official, index) => (
            <OfficialCard
              key={`${official.name}-${official.position}-${index}`}
              name={official.name}
              position={official.position}
              image={official.image}
            />
          ))}
        </div>
      </Container>
    </section>
  );
}